module.exports = __webpack_public_path__ + "assets/img/Gourmet-Basket-eBook-w960.5badb4aa.webp";